<div class="card scrollbar">
    <div class="card-content">
      <div class="card-body" *ngIf="accountResponse">
        <div class="cst-acc-card mb20">
        <div class="row">
          <div class="col-4">
            <div class="af-form-group">
              <label translate>{{'lblAccountName' | translate}} :</label>
              <div class="lbl-info">
                {{accountResponse.customerName}}
              </div>
            </div>  
          </div>
          <div class="col-4">
            <div class="af-form-group">
              <label>{{'lblAccountNo' | translate}} :</label>
              <div class="lbl-info">
                {{accountResponse.customerNo}}
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="af-form-group">
              <label>{{'lblCustomerGroup' | translate}} :</label>
              <div class="lbl-info">
                {{accountResponse.customerGroup}}
              </div>
            </div>  
          </div>
          <div class="col-4">
            <div class="af-form-group">
              <label translate>{{'lblSalutation' | translate}} :</label>
              <div class="lbl-info">
                {{accountResponse.salutation}}
              </div>
            </div>  
          </div>
          <div class="col-4">
            <div class="af-form-group">
              <label translate>{{'lblRegistrationNo' | translate}} :</label>
              <div class="lbl-info">
                {{accountResponse.registrationOrPersonNumber}}
              </div>
            </div>  
          </div>
          <div class="col-4">
            <div class="af-form-group">
              <label>{{'lblRegistrationDate' | translate}} :</label>
              <div class="lbl-info">
                {{accountResponse.registrationOrBirthDate | date:'short'}}
              </div>
            </div>  
          </div>
        </div>
        </div>
        <div class="cst-acc-card mb20">
        <div class="row">  
          <div class="col-4">
            <div class="af-form-group">
              <label translate>{{'lblAddress1' | translate}} :</label>
              <div class="lbl-info">
                {{accountResponse.addressLine1}}
              </div>
            </div>  
          </div>
          <div class="col-4">
            <div class="af-form-group">
              <label translate>{{'lblAddress2' | translate}} :</label>
              <div class="lbl-info">
                {{accountResponse.addressLine2}}
              </div>
            </div>  
          </div>

          <div class="col-4">
            <div class="af-form-group">
              <label translate>{{'lblPostCode' | translate}} :</label>
              <div class="lbl-info">
                {{accountResponse.pincode}}
              </div>
            </div>  
          </div>

          <div class="col-4">
            <div class="af-form-group">
              <label translate>{{'lblCity' | translate}} :</label>
              <div class="lbl-info">
                {{accountResponse.city}}
              </div>
            </div>  
          </div>

          <div class="col-4">
            <div class="af-form-group">
              <label translate>{{'lblCountry' | translate}} :</label>
              <div class="lbl-info">
                {{accountResponse.country}}
              </div>
            </div>  
          </div>

          <div class="col-4">
            <div class="af-form-group">
              <label translate>{{'lblEmail' | translate}} :</label>
              <div class="lbl-info">
                {{accountResponse.email}}
              </div>
            </div>  
          </div>

          <div class="col-4">
            <div class="af-form-group">
              <label translate>{{'lblMobile' | translate}} :</label>
              <div class="lbl-info">
                {{accountResponse.mobileNo}}
              </div>
            </div>  
          </div>

          <div class="col-4">
            <div class="af-form-group">
              <label translate>{{'lblPhoneNumber' | translate}} :</label>
              <div class="lbl-info">
                {{accountResponse.phoneNumber}}
              </div>
            </div>  
          </div>

          <div class="col-4">
            <div class="af-form-group">
              <label translate>{{'lblActive' | translate}} :</label>
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" [checked]="accountResponse.isActive" 
                  readonly [(ngModel)]="accountResponse.isActive">
                <label class="custom-control-label"></label>
              </div>
            </div>  
          </div>
          </div>
          </div>
      </div>
    </div>
    
  </div>